export * from './NativeBaseProvider';
export * from './extendTheme';

export {
  useColorMode,
  useColorModeValue,
  useAccessibleColors,
} from './color-mode';

export type { INativebaseConfig } from './NativeBaseContext';

export type {
  StorageManager,
  ColorMode,
  ColorModeOptions,
  IColorModeProviderProps,
  IColorModeContextProps,
} from './color-mode';

export { ToastProvider } from '../components/composites/Toast';
